var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,9L7.2,24.3c-0.8,1.3,0.2,2.9,1.7,2.9h17.7c1.5,0,2.4-1.6,1.7-2.9L19.4,9C18.6,7.7,16.8,7.7,16,9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.2,19.9h-1c-0.4,0-0.6-0.3-0.7-0.6l-0.4-6c0-0.4,0.3-0.7,0.7-0.7h1.8c0.4,0,0.7,0.3,0.7,0.7l-0.4,6 C18.8,19.6,18.6,19.9,18.2,19.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 17.7,
    cy: 22.8,
    r: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.9817b626b1ca61f2939e7c87d516e7bc.svg";
export { ForwardRef as ReactComponent };